import { TP } from 'constants/consts';

export const GET_USER_NOTIFICATIONS = 'app/Notifications/GET_USER_NOTIFICATIONS';
export const UPDATE_NOTIFICATIONS = 'app/Notifications/UPDATE_NOTIFICATIONS';

export const NOTIFICATIONS_TYPES = {
  PROFILE_ACCESS_REQUEST_CREATED: 'profile_access_request_created',
  PROFILE_ACCESS_REQUEST_ACCEPTED: 'profile_access_request_accepted',
  PAYMENT_FAILED: 'payment_failed',
};

export const EDIT_PROFILE_TABS = {
  images: {
    key: 'photos',
    name: `${TP}.FN_TAB_PHOTOS`,
  },
  reviews: {
    key: 'reviews',
    name: `${TP}.FN_TAB_REVIEWS`,
  },
  schedule: {
    key: 'schedule',
    name: `${TP}.FN_TAB_SCHEDULE`,
  },
  videos: {
    key: 'videos',
    name: `${TP}.FN_TAB_VIDEOS`,
  },
};
